import yellowCardBg from '../../appAssets/yellow-card-bg.png';
import blueCardBg from '../../appAssets/blue-card-bg.png';
import orangeCardBg from '../../appAssets/orange-card-bg.png';
import redCardBg from '../../appAssets/red-card-bg.png';

export const CARD_COLORS = ['yellow', 'blue', 'orange', 'red'] as const;
export type CardColor = (typeof CARD_COLORS)[number];

export interface ChatQuestionOption {
  option: string;
  optionValue: string;
  optionView: string;
  optionAudioUrl: string | null;
  optionAudioDuration: string | null;
  optionViewAudioUrl: string | null;
  optionViewAudioDuration: string | null;
}

export interface ChatQuestion {
  _id: string;
  documentId: string;
  question: string;
  audioUrl: string;
  audioDuration: string;
  options: ChatQuestionOption[];
  selCompetency: string | null;
  storyImageUrl: string | null;
  storyName: string | null;
  type: string;
  complexity: string;
  compassAttribute: string | null;
  critical: boolean | null;
}

export interface ConversationBlock {
  name?: string;
  conversations: Array<{
    object: Array<{
      content: string;
      audio: string;
      duration: string;
      characterImage?: string;
      blockObjects?: Array<{url: string; linkTo: string}>;
    }>;
  }>;
  userActions: Array<{
    component: string;
    buttonText: string;
  }>;
}

export const GAME_INTRO_CONVERSATIONS: ConversationBlock[] = [
  {
    conversations: [
      {
        object: [
          {
            content: "I'll ask you a question and you can ask me one next.",
            audio:
              'https://assets.prod.yetimyfriend.com/troo_i_will_ask_you_a_question_and_you_can_ask_me_one_next_938281f564.mp3',
            duration: '4920',
          },
        ],
      },
    ],
    userActions: [],
  },
  {
    conversations: [
      {
        object: [
          {
            content: 'Are you ready to play?',
            audio:
              'https://assets.prod.yetimyfriend.com/troo_are_you_ready_to_play_446ba8301b.mp3',
            duration: '1704',
          },
        ],
      },
    ],
    userActions: [],
  },
  {
    conversations: [
      {
        object: [
          {
            content: "Pick a card and let's go!",
            audio:
              'https://assets.prod.yetimyfriend.com/troo_pick_a_card_and_let_s_go_a6d18f2a1d.mp3',
            duration: '2664',
          },
        ],
      },
    ],
    userActions: [],
  },
];

export const POST_ANSWER_CONVERSATIONS: ConversationBlock[] = [
  {
    conversations: [
      {
        object: [
          {
            content: 'Thanks for sharing that with me!',
            audio:
              'https://assets.prod.yetimyfriend.com/troo_thanks_for_sharing_that_with_me_f308d3455c.mp3',
            duration: '1824',
          },
        ],
      },
    ],
    userActions: [],
  },
  {
    conversations: [
      {
        object: [
          {
            content: "Now, it's YOUR turn to ask me a question.",
            audio:
              'https://assets.prod.yetimyfriend.com/troo_now_it_s_your_turn_to_ask_me_a_question_6f8dabd742.mp3',
            duration: '2880',
          },
        ],
      },
    ],
    userActions: [],
  },
];

export const CARD_BORDER_COLORS: Record<CardColor, string> = {
  yellow: '#FFC047',
  blue: '#76B8F5',
  orange: '#F49E51',
  red: '#F85D48',
};

export const CARD_BG_IMAGES: Record<CardColor, string> = {
  yellow: yellowCardBg,
  blue: blueCardBg,
  orange: orangeCardBg,
  red: redCardBg,
};
